import { getTemple } from "../../js/storage";
import { downLoadBlobFile, getKeyTitle } from "../../js/tool";

export const statusOptions = [
  { key: 1, title: "正常" },
  { key: 2, title: "异常" },
];

export const getStatusText = function (value) {
  return getKeyTitle(statusOptions, value);
};

const tipList = [
  "1. 卫生、公共设施完好情况",
  "2. 防火、防盗安全隐患",
  "3. 指示标牌完全、清晰、明确",
  "4. 弘法宣传栏信息准确，完好",
  "5. 大公厕卫生状况",
  "6. 公共秩序和安全",
  "7. 设备设施运行情况",
];

export default {
  name: "公共区域日常巡逻",
  url: "/admin/record-daily-patrols", // rest接口表名
  query: "&sort=-id", // rest接口query参数
  searchKeyType: {
    date: function (form, key) {
      let value = form[key];
      let res = "";
      if (value?.length > 0) {
        res = `&filter[create_time][gte]=${value[0]} 00:00:00&filter[create_time][lte]=${value[1]} 23:59:59`;
      }
      return res;
    },
  },
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      {
        title: "提交时间",
        dataIndex: "create_time",
        customRender: (text) => text?.slice(0, -3),
      },
      {
        title: "提交人",
        dataIndex: "wx_user_id",
        customRender: (text) => <open-data type="userName" openid={text} />,
      },
      { title: "状态", dataIndex: "status", customRender: getStatusText },
    ];
  },
  // 列表查询表单
  queryForm: [
    {
      key: "wx_user_id",
      label: "提交人",
      component: "select-book",
      props: {
        type: "user",
      },
    },
    {
      key: "date",
      label: "提交日期",
      component: "a-range-picker",
      props: {
        placeholder: ["开始日期", "结束日期"],
        format: "YYYY-MM-DD",
        valueFormat: "YYYY-MM-DD",
        allowClear: true,
        class: "range-picker",
      },
      style: {
        width: "240px",
      },
    },
    {
      key: "status",
      label: "状态",
      component: "a-select",
      props: {
        options: statusOptions,
        placeholder: "选择状态查询",
        allowClear: true,
      },
      style: {
        width: "200px",
      },
    },
  ],
  buttons: [
    {
      name: "数据导出",
      component: "a-button",
      type: "primary",
      props: {
        type: "primary",
      },
      style: {
        "margin-left": "8px",
      },
      value: null,
      listeners: {
        click() {
          if (this.exporting) return;
          this.$set(this, "exporting", false);
          const temple = getTemple();
          let url = `/admin/record-daily-patrols/export?temple_id=${temple}`;
          const form = this.$refs.dataList.form;
          if (form.wx_user_id) {
            url += `&wx_user_id=${form.wx_user_id}`;
          }
          if (form.date?.length === 2) {
            url += `&start_time=${form.date[0]}&end_time=${form.date[1]}`;
          }
          if (form.status) {
            url += `&status=${form.status}`;
          }
          this.$axios(url, { noTempleFilter: true, responseType: "blob" })
            .then((res) => {
              downLoadBlobFile(res, "公共区域日常巡逻数据");
            })
            .finally(() => {
              this.exporting = false;
            });
        },
      },
    },
  ],
  // 新增/编辑查询表单
  items: [],
  // 详情接口expand字段
  expand: "",
  init: {}, // 新增实体初始化字段
  dealDetail: function (detail) {
    return new Promise((resolve) => {
      detail.files = detail.file ? JSON.parse(detail.file) : [];
      resolve();
    });
  },
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "提交时间", key: "create_time", slot: (entity) => <span>{entity.create_time?.slice(0, -3)}</span> },
      {
        label: "提交人",
        key: "wx_user_id",
        slot: (entity) => <open-data type="userName" openid={entity.wx_user_id} />,
      },
      { label: "巡查日期", key: "date" },
      { label: "巡查时间", key: "patrol_time" },
      {
        label: "巡查内容",
        key: "tip",
        slot: () => (
          <ul>
            {tipList.map((tip) => (
              <li>{tip}</li>
            ))}
          </ul>
        ),
      },
      {
        label: "巡查状态",
        key: "status",
        slot: (entity) => <span>{getStatusText(entity.status)}</span>,
      },
      { label: "备注", key: "content" },
    ];
  },
};
